import { ROUTES } from 'constants/routes';
import { IRoute } from 'types/common';
import RootPage from './RootPage';

const routes: IRoute[] = [
  {
    path: ROUTES.ROOT,
    exact: true,
    Component: RootPage,
  },
];

export default routes;
